import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { AppConfig } from '../../public-api';

@Injectable()
export class MockAppConfigLoaderService<T extends AppConfig> {
  private appConfig: AsyncSubject<T> = new AsyncSubject<T>();

  loadAppConfig(appConfigData: T) {
    this.appConfig.next(appConfigData);
    this.appConfig.complete();
    return Promise.resolve(true);
  }

  getConfig$(): AsyncSubject<T> {
    return this.appConfig;
  }
}
